import '.bq{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.e{align-items:center;}.ssr-plugin'
import '.z{position:absolute;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.ch{right:-4px;}.ssr-plugin'
import '.ci{width:1.5rem;}.ssr-plugin'
import '.cj{height:1.5rem;}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.ck{background-color:var(--primary-red);}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  onDelete,
  onCancelDelete,
}: {
  src: string
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="bq a n e"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--shades-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="a n e z cg ch ci cj ad ck ar"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--shades-white)" />
    </div>
  )
}
